var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "final-selection" }, [
    _c("p", { staticClass: "print-disclaimer" }, [
      _vm._v(
        "Disclaimer: This is a snapshot of the Tech Platform Assistant. Please note this tool is updated regularly; you can visit the live site for the most current information."
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "final-selection__head" }, [
      _c("h2", [_vm._v("Final Selection")]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "link--go-back",
          attrs: { href: "#" },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.goBackEvent($event)
            }
          }
        },
        [_vm._v("\n      Go Back\n    ")]
      )
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "final-selection__body" }, [
      _c("div", { staticClass: "body__left" }, [
        _c("div", { staticClass: "body__v-bar-content" }, [
          _c(
            "div",
            { staticClass: "body__content" },
            [
              _c("h2", [_vm._v("Next Steps")]),
              _vm._v(" "),
              _vm.currentPlatform
                ? [
                    _vm.currentPlatform.preferred
                      ? _c("p", { staticClass: "body__preferred-solution" }, [
                          _vm._v("Preferred Solution")
                        ])
                      : _vm._e()
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c("section", {
                domProps: { innerHTML: _vm._s(_vm.nextStepsContent) },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.handleClick($event)
                  }
                }
              }),
              _vm._v(" "),
              _vm.currentPlatform
                ? [
                    _vm.currentPlatform.features
                      ? [
                          _vm.currentPlatform.features.propr_path
                            ? _c("blockquote", { staticClass: "propr-path" }, [
                                _c("h3", [_vm._v("Propr")]),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass: "propr-path__content",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.currentPlatform.features.propr_path
                                        .notes
                                    )
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.handleClick($event)
                                    }
                                  }
                                })
                              ])
                            : _vm._e()
                        ]
                      : _vm._e()
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "final-selection__session" },
                [
                  _c(
                    "router-link",
                    {
                      attrs: { to: { name: "Home" } },
                      nativeOn: {
                        click: function($event) {
                          return _vm.startOverEvent($event)
                        }
                      }
                    },
                    [
                      _c("unum-button", [
                        _vm._v("\n                Start Over\n              ")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "body__right" }, [
        _c(
          "div",
          { staticClass: "body__v-bar-content" },
          [
            !_vm.isProductHosted ? _c("router-view") : _vm._e(),
            _vm._v(" "),
            _vm.isNullPlatform && !this.isFormSent
              ? _c(
                  "form",
                  {
                    staticClass: "form-unknown-platform",
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return _vm.collectUnknownPlatform($event)
                      }
                    }
                  },
                  [
                    _c("p", [
                      _vm._v(
                        "\n            We are constantly enhancing our connection portfolio and capabilities to meet the\n            shifting needs of our customer. If you believe an integration with this partner would\n            be advantageous, please provide the following information:\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("unum-textbox", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      attrs: {
                        label: "Platform Name",
                        placeholder: "Enter Platform",
                        name: "unknown-platform__name",
                        "data-vv-value-path": "unknown-platform__name",
                        errorBag: _vm.errors
                      },
                      model: {
                        value: _vm.unknownPlatform.platformName,
                        callback: function($$v) {
                          _vm.$set(_vm.unknownPlatform, "platformName", $$v)
                        },
                        expression: "unknownPlatform.platformName"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        class: [
                          "unum-field-checkbox",
                          {
                            "has-error": _vm.errors
                              ? _vm.errors.has(
                                  "unknown-platform__offered-products--individual"
                                ) ||
                                _vm.errors.has(
                                  "unknown-platform__offered-products--group"
                                )
                              : false
                          }
                        ]
                      },
                      [
                        _vm._m(0),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-unknown-platform__flex" },
                          [
                            _c(
                              "checkbox",
                              {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: !_vm.isOneSelected_offeredProducts
                                      ? "required"
                                      : false,
                                    expression:
                                      "!isOneSelected_offeredProducts ? 'required' : false"
                                  }
                                ],
                                attrs: {
                                  name:
                                    "unknown-platform__offered-products--individual",
                                  value: "individual",
                                  "data-vv-value-path":
                                    "unknown-platform__offered-products--individual",
                                  "data-vv-validate-on": "none"
                                },
                                model: {
                                  value: _vm.unknownPlatform.offeredProducts,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.unknownPlatform,
                                      "offeredProducts",
                                      $$v
                                    )
                                  },
                                  expression: "unknownPlatform.offeredProducts"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                Individual\n              "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "checkbox",
                              {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: !_vm.isOneSelected_offeredProducts
                                      ? "required"
                                      : false,
                                    expression:
                                      "!isOneSelected_offeredProducts ? 'required' : false"
                                  }
                                ],
                                attrs: {
                                  name:
                                    "unknown-platform__offered-products--group",
                                  value: "group",
                                  "data-vv-value-path":
                                    "unknown-platform__offered-products--group",
                                  "data-vv-validate-on": "none"
                                },
                                model: {
                                  value: _vm.unknownPlatform.offeredProducts,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.unknownPlatform,
                                      "offeredProducts",
                                      $$v
                                    )
                                  },
                                  expression: "unknownPlatform.offeredProducts"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                Group\n              "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        class: [
                          "unum-field-datepicker",
                          {
                            "has-error": _vm.errors
                              ? _vm.errors.has(
                                  "unknown-platform__planned-enrollment-date"
                                )
                              : false
                          }
                        ]
                      },
                      [
                        _c("p", [
                          _vm._v("What is your planned enrollment date?")
                        ]),
                        _vm._v(" "),
                        _c("unum-textbox", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          attrs: {
                            type: "date",
                            name: "unknown-platform__planned-enrollment-date",
                            placeholder: "Planned Enrollment Date",
                            "data-vv-value-path":
                              "unknown-platform__planned-enrollment-date"
                          },
                          model: {
                            value: _vm.unknownPlatform.plannedEnrollmentDate,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.unknownPlatform,
                                "plannedEnrollmentDate",
                                $$v
                              )
                            },
                            expression: "unknownPlatform.plannedEnrollmentDate"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("unum-button", [_vm._v("Submit")])
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            this.isFormSent
              ? _c(
                  "div",
                  { staticClass: "form-sent-message" },
                  [
                    _c("h3", [
                      _vm._v(
                        "Thanks for helping us serve our customers better."
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "router-link",
                      {
                        attrs: { to: { name: "Wizard" } },
                        nativeOn: {
                          click: function($event) {
                            return _vm.unknownPlatformWizardButtonEvent($event)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n            Are you interested in other platforms that are available for your case?\n          "
                        )
                      ]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isProductHosted
              ? _c(
                  "div",
                  { staticClass: "form-sent-message" },
                  [
                    _c("h3", [
                      _vm._v(
                        "\n            We can help you find integrated platforms that are compatible with your enrollment\n            platform requirements.\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "router-link",
                      {
                        attrs: { to: { name: "Wizard" } },
                        nativeOn: {
                          click: function($event) {
                            return _vm.productHostedWizardButtonEvent($event)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n            Help me Choose Another Platform\n          "
                        )
                      ]
                    )
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "\n              Will you be offering individual and/or group products?\n              "
      ),
      _c("span", { staticClass: "text-help" }, [
        _vm._v("(Select all that apply)")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fa815034", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa815034","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FinalSelection.vue
// module id = null
// module chunks = 